export default __webpack_public_path__ + "static/favicon-ad92910fce1714bf731a6970a35331a5.png";